<div page-content [fullWidth]="true">
  <div actions class="uk-section-primary uk-preserve-color">
    <sidebar-mobile-toggle class="uk-hidden@m uk-display-block uk-padding-small"></sidebar-mobile-toggle>
  </div>
  <div inner>
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small " #exportContent>
      <div class="uk-container">

        <div class="uk-flex uk-flex-between uk-flex-middle uk-visible@m">
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
                 class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Access Publications for {{ year }}</h4>
            </div>
          </div>
          <!--          <h4>Open Access Publications</h4>-->
          <div class="uk-flex uk-flex-center uk-flex-none"
               (click)="exportToPDF([exportContent, exportContent1, exportContent2, exportContent3, exportContent4, exportContent5], 'Open Access Publications')"
               style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
                 style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                    style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                      data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>

        <div class="uk-hidden@m">
          <!--          <h4>Open Access Publications</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
                 class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Access Publications for {{ year }}</h4>
            </div>
          </div>
          <div class="uk-flex uk-flex-right"
               (click)="exportToPDF([exportContent, exportContent1, exportContent2, exportContent3, exportContent4, exportContent5], 'Open Access Publications')"
               style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
                 style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                    style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                      data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>

        <!--        <div class="uk-flex uk-flex-middle uk-margin-bottom">-->
        <!--          <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"-->
        <!--               class="flag-image" width="42" height="42" alt="rounded flag image">-->
        <!--          <div class="uk-margin-small-left">-->
        <!--            <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Access Publications</h4>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>
    </div>

    <div class="section-hidden-notice-band">
      <div class="uk-container">
        <app-section-hidden-notice sectionName="Open Access Publications"></app-section-hidden-notice>
      </div>
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent1>
      <div class="uk-container">

        <p class="uk-text-lead">Open Access (OA) represents a transformative approach within the scholarly communication
          landscape, aiming to make research outputs freely accessible to all, without subscription or price barriers.
          The graphics below provides a high-level overview of key indicators tracking the progress of OA publishing and
          policies in selected country.</p>

        <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-medium-top">
          <h5>General Overview of Open Access for {{ year }}</h5>
        </div>

        <div class="uk-grid-small uk-grid-match" data-uk-grid>

          @if (hasAnyLeftCardVisible()) {
            <div class="uk-width-1-1 uk-width-3-5@m uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body">
                <div
                  class="uk-child-width-1-1@s uk-child-width-1-2@m uk-grid-small uk-grid-match uk-flex uk-flex-center"
                  data-uk-grid data-uk-height-match="target: > * .uk-card">
                  <!-- Card 1 -->
                  <app-card-config indicatorId="16" colorClass="openaire-graph visualisation-card">
                    @if (OAPubsPercentage[1] !== null) {
                      <app-info-card
                        [titleHtml]="'OA Publication in ' + countryName + ' (OA vs Closed)'"
                        [value]="OAPubsPercentage[1]"
                        [unit]="'%'"
                        [diff]="OAPubsPercentageDiff"
                        colorClass="openaire-graph visualisation-card">
                      </app-info-card>
                    }
                  </app-card-config>
                  <!-- Card 2 -->
                  <app-card-config indicatorId="17" colorClass="eosc-sb visualisation-card">
                    @if (rfoPubsPercentage[1] !== null) {
                      <app-info-card
                        [titleHtml]="'RFOs with Policy on OA Publication'"
                        [value]="rfoPubsPercentage[1]"
                        [unit]="'%'"
                        [diff]="rfoPubsPercentageDiff"
                        colorClass="eosc-sb visualisation-card">
                      </app-info-card>
                    }
                  </app-card-config>
                  <!-- Card 3 -->
                  <app-card-config indicatorId="18" colorClass="eosc-sb visualisation-card">
                    @if (rpoPubsPercentage[1] !== null) {
                      <app-info-card
                        [titleHtml]="'RPOs with Policy on OA Publication'"
                        [value]="rpoPubsPercentage[1]"
                        [unit]="'%'"
                        [diff]="rpoPubsPercentageDiff"
                        colorClass="eosc-sb visualisation-card">
                      </app-info-card>
                    }
                  </app-card-config>
                  <!-- Card 4 -->
                  <app-card-config indicatorId="19" colorClass="eosc-sb visualisation-card">
                    @if (financialInvestment[1] !== null && financialInvestment[1]) {
                      <app-info-card
                        [titleHtml]="'Financial Investments in OA Publications'"
                        [value]="financialInvestment[1]"
                        [unit]="'mil Euro'"
                        [diff]="financialInvestmentPercentageDiff"
                        colorClass="eosc-sb visualisation-card">
                      </app-info-card>
                    }
                  </app-card-config>
                </div>
              </div>
            </div>
          }

          <!-- Right Card (2/5) -->
          <app-card-config indicatorId="20" class="uk-width-1-1 uk-width-2-5@m uk-animation-fade">
            <div>
              <div class="uk-card uk-card-default uk-card-body eosc-sb visualisation-card">
                <div class="uk-margin-top">
                  <h6 class="uk-flex uk-flex-between uk-margin-remove">
                    National Policy on Open Access
                    <span
                      class="material-symbols-outlined"
                      [ngClass]="{
                      'up-arrow-color': nationalPolicyResponse === 'Yes',
                      'down-arrow-color': nationalPolicyResponse === 'No',
                      'unanswered-color': nationalPolicyResponse === null || nationalPolicyResponse === undefined
                    }">
                {{
                        nationalPolicyResponse === 'Yes' ? 'check' :
                          nationalPolicyResponse === 'No' ? 'close' :
                            'question_mark'
                      }}
              </span>
                  </h6>
                  @if (policyMandatory === 'Yes') {
                    <p class="uk-text-primary uk-text-bolder uk-margin-remove-top">Mandatory policy</p>
                  }
                  @if (nationalPolicyClarification !== null) {
                    <read-more-text [maxHeight]="68" [text]="nationalPolicyClarification"></read-more-text>
                  }
                </div>
                <div class="uk-margin-top">
                  <h6 class="uk-flex uk-flex-between">
                    Financial Strategy on Open Access
                    <span
                      class="material-symbols-outlined"
                      [ngClass]="{
                      'up-arrow-color': financialStrategyResponse === 'Yes',
                      'down-arrow-color': financialStrategyResponse === 'No',
                      'unanswered-color': financialStrategyResponse === null || financialStrategyResponse === undefined
                    }">
                {{
                        financialStrategyResponse === 'Yes' ? 'check' :
                          financialStrategyResponse === 'No' ? 'close' :
                            'question_mark'
                      }}
              </span>
                  </h6>
                  @if (financialStrategyResponse) {
                    <read-more-text [maxHeight]="68" [text]="financialStrategyClarification"></read-more-text>
                  }
                </div>
                <div class="uk-margin-top">
                  <h6 class="uk-flex uk-flex-between">
                    Monitoring on Open Access
                    <span
                      class="material-symbols-outlined"
                      [ngClass]="{
                      'up-arrow-color': monitoringResponse === 'Yes',
                      'down-arrow-color': monitoringResponse === 'No',
                      'unanswered-color': monitoringResponse === null || monitoringResponse === undefined
                    }">
                {{
                        monitoringResponse === 'Yes' ? 'check' :
                          monitoringResponse === 'No' ? 'close' :
                            'question_mark'
                      }}
              </span>
                  </h6>
                  @if (monitoringResponse) {
                    <read-more-text [maxHeight]="68" [text]="monitoringClarification"></read-more-text>
                  }
                </div>
              </div>
            </div>
          </app-card-config>

          <div>
            <p><span class="uk-text-bold">Data source:</span>
              Survey on National Contributions to EOSC and Open Science {{ year }} -
              showing data for {{ year }}, except financial contributions, which reflect the previous year
              ({{ +year - 1 }});
              OpenAIRE Graph data for {{ year }} (updated on {{ lastUpdateDate }}).
            </p>
          </div>

        </div>

      </div>
    </div>

    <div #exportContent2>
      @if (hasSurveyPublicationData()) {
        <div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
          <div class="uk-container">
            <app-card-config indicatorId="21">
              <div class=" uk-animation-fade">
                <div class="uk-card uk-card-body uk-card-default uk-width-1-1 noads visualisation-card">
                  <read-more [maxHeight]="300">
                    <h6 class="uk-margin-bottom">Open Access Landscape in {{ countryName }}</h6>
                    <div class="uk-text-meta">This information has been compiled by the National Open Access Desks
                      on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd' }}
                    </div>
                    <div class="uk-margin-medium-top" id="open_access_publishing">
                      <div class="uk-text-secondary uk-margin-small-bottom">Open Access Publishing</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question7']) {
                        <div
                          [innerHTML]="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question7']"
                          class="uk-margin-remove-top"></div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </app-card-config>
          </div>
        </div>
      }
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent3>
      <div class="uk-container">
        <app-card-config indicatorId="22">
          <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body uk-animation-fade">
            <div class="uk-grid">
              <div class="uk-width-1-1">
                <app-stacked-column [categories]="stackedColumnCategories"
                                    [legend]="legend"
                                    [series]="stackedColumnSeries"
                                    [yAxis]="yAxisTitle"
                                    [pointFormat]="tooltipPointFormat"
                                    [stackLabels]="false"
                                    [dataLabels]="false"
                                    [height]="smallScreen ? 1000 : 750"
                                    [title]="'Trend of Access to Publications in ' + countryName"
                                    [caption]="'<p class=\'uk-text-justify\'>The graph provides a view of the publications evolution and its access type from 2015 to ' + (dataShareService.year$ | async) + ' in the selected country. Each bar in the graph represents the total number of publications for a given year, segmented by access type categories (categories based on <a href=&quot;https://vocabularies.coar-repositories.org/access_rights/access_rights_for_dspace_en.xml&quot; target=\'_blank\'>https://vocabularies.coar-repositories.org/access_rights/access_rights_for_dspace_en.xml</a>).</p>'
                                  + '<p><strong>Data Source:</strong> OpenAIRE Graph (updated on ' + lastUpdateDate + ').</p>'">
                </app-stacked-column>
              </div>
            </div>
          </div>
        </app-card-config>
      </div>
    </div>


      <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent4>
        <div class="uk-container">
          <app-card-config indicatorId="23">
            <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body">
              <app-stacked-column [categories]="stackedColumn2Categories"
                                  [legend]="legend"
                                  [series]="stackedColumn2Series"
                                  [title]="'Distribution of Open Access Types by Different Scholarly Publication Outputs in ' + countryName"
                                  [yAxis]="yAxisTitle2"
                                  [pointFormat]="tooltipPointFormat"
                                  [plotFormat]="dataLabels_format"
                                  [stackLabels]="false"
                                  [stacking]="stacking"
                                  [height]="smallScreen ? 1000 : 750"
                                  [caption]="'<p class=\'uk-text-justify\'>The graph displays the distribution of OA types across different scholarly publication categories, revealing distinct preferences and practices in the dissemination of research outputs. This visualization provides insight into the diverse adoption rates and strategies for OA across various academic outputs. Understanding these differences is crucial for identifying specific barriers and opportunities within each publication category, thereby guiding stakeholders in tailoring interventions that encourage broader adoption of OA. This targeted approach can significantly contribute to enhancing the accessibility of knowledge, fostering a more open and collaborative scientific community.</p>'
                                + '<p><strong>Data Source: </strong> OpenAIRE Graph data for ' + year + ' (updated on ' + lastUpdateDate + ')</p>'">
              </app-stacked-column>
            </div>
        </app-card-config>
        </div>
      </div>


      <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent5>
        <div class="uk-container">
          <app-card-config indicatorId="24">
          <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body">
            <app-multi-chart [series]="bar"
                             [legendOptions]="legend"
                             [categories]="barCategories"
                             stacking="normal"
                             [titles]="barChartTitles"
                             [height]="smallScreen ? 750 : 550"
                             [duplicateXAxis]="true"
                             [yAxisLabels]="true"
                             [dataLabelFormat]="'{(abs value)}'"
                             [tooltip]="'<b>{series.name},</b> {point.category}<br/>{(abs point.y)}'"
                             [caption]="'<p class=\'uk-text-justify\'>This graph illustrates the distribution of OA types within various scientific disciplines including Medical and Health Sciences, Engineering and Technology, Agricultural Sciences, Natural Science, Social Sciences, and Humanities.</p>'
                           + '<strong>Data Source: </strong> OpenAIRE Graph data for ' + year + ' (updated on '+ lastUpdateDate +')'">
            </app-multi-chart>
          </div>
          </app-card-config>
        </div>
      </div>
  </div>
</div>
